// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import { logout } from "../../utils/slices/auth";
import { store } from "../../utils/store";
import { loginRoute } from "../login/route";
import { rootRoute } from "../root/route";

export const logoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "logout",
  beforeLoad() {
    store.dispatch(logout());
    throw redirect({ to: loginRoute.to });
  },
});
